import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import DatePicker from "../../Components/Datepicker_Basic";
/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import GridFunctions from "../../Services/agGrid/ag-Grid-functions";
import Input from "../../Components/Input_Basic";
function DB10010(props) {
  React.useEffect(() => {
    document.title = "주문현황 모니터링";
    const element = document.getElementById("topbar");
    element.innerHTML =
      "<h1>" +
      "<span class='bullet'>" +
      "</span>" +
      "<strong class='depth-1'>" +
      "대시보드" +
      "	</strong>" +
      "<span class='divider' >" +
      "</span>" +
      "<strong'>주문현황 모니터링</strong>" +
      "</h1>";
  }, []);

  const gridRef = React.useRef();
  const columnDefs = [
    {
      field: "plantCd",
      headerName: "사업장",
    },

    {
      field: "itemNm",
      headerName: "품목명",
      chartDataType: "category",
    },
    {
      field: "itemCd",
      headerName: "품목코드",
    },
    {
      field: "soNo",
      headerName: "주문번호",
    },
    {
      field: "soDt",
      headerName: "주문일자",
    },
    {
      field: "custCd",
      headerName: "거래처코드",
    },
    {
      field: "custNm",
      headerName: "거래처",
    },

    {
      field: "itemQty",
      headerName: "주문수량",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
    },
    {
      field: "workQty",
      headerName: "작업수량",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
    },
    {
      field: "lossQty",
      headerName: "차이",
      valueFormatter: (params) => {
        var formatted = params.value
          ? parseFloat(params.value)
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : 0;
        return formatted;
      },
    },
    {
      field: "stusNm",
      headerName: "상태",
    },
  ];
  const chartThemes = React.useMemo(() => {
    return ["ag-pastel", "ag-vivid"];
  }, []);
  const popupParent = React.useMemo(() => {
    return document.body;
  }, []);
  const chartThemeOverrides = React.useMemo(() => {
    return {
      common: {
        axes: {
          number: {
            title: {
              enabled: true,
              formatter: (params) => {
                return params.boundSeries.map((s) => s.name).join(" / ");
              },
            },
          },
        },
      },
      column: {
        series: {
          strokeWidth: 2,
          fillOpacity: 0.8,
        },
      },
      line: {
        series: {
          strokeWidth: 5,
          strokeOpacity: 0.8,
        },
      },
    };
  }, []);

  const onFirstDataRendered = React.useCallback((params) => {
    gridRef.current.api.createRangeChart({
      chartType: "customCombo",
      cellRange: {
        columns: ["itemNm", "itemQty", "workQty", "lossQty"],
      },
      seriesChartTypes: [
        { colId: "itemQty", chartType: "groupedColumn", secondaryAxis: true },
        { colId: "workQty", chartType: "groupedColumn", secondaryAxis: true },
        { colId: "lossQty", chartType: "groupedColumn", secondaryAxis: true },
      ],
      aggFunc: "sum",
      suppressChartRanges: true,
      chartContainer: document.querySelector("#myChart"),
    });
  }, []);
  return (
    <div>
      <Section />
      <Card
        wrapStyle={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginRight: "5px" }}
            selected={props.startDate}
            onChange={(e) => {
              props.setStartDate(e);
            }}
          />
          ~
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginRight: "5px" }}
            selected={props.endDate}
            onChange={(e) => {
              props.setEndDate(e);
            }}
          />
          품목코드/명
          <Input
            type={"text"}
            value={props.orderNumber}
            onChange={(e) => {
              props.setParamsItemCd(e.target.value);
            }}
            onClick={() => {}}
            onKeyDown={(e) => {
              if (e.keyCode == 13) {
                props.Init();
              }
            }}
          />{" "}
        </div>

        <AuthGroupButton
          pageName="DB10010"
          target="G01"
          refreshNone="none"
          selectFunc={() => props.Init()}
        />
      </Card>

      <div
        className="ag-theme-alpine no-scroll"
        style={{ width: "100%", height: "0px" }}
      >
        <AgGridReact
          ref={gridRef}
          animateRows={true}
          columnDefs={columnDefs}
          chartThemes={chartThemes}
          enableCharts={true}
          popupParent={popupParent}
          chartThemeOverrides={chartThemeOverrides}
          onFirstDataRendered={onFirstDataRendered}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            floatingFilter: true,
          }}
          onCellValueChanged={(e) =>
            GridFunctions.onCellValueChanged(
              e,
              gridRef,
              props.setChangedRowData
            )
          }
          groupDisplayType={"custom"}
          rowData={props.rowData}
          onSelectionChanged={() =>
            GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
          }
        />
      </div>
      <div className="dashboard">
        <div id="myChart" className="ag-theme-alpine"></div>
      </div>
    </div>
  );
}

export default DB10010;
